<template>
  <div class="w-100">
    <div class="row px-4">
      <div class="col-sm-4 border-kiri bg-primary">
        <div class="swiper">
          <!-- Additional required wrapper -->

          <div class=" text-white text-center">
            <!-- Slides -->
            <div class=" pt-3">

              <div class="row">
                <div class="panel img-kiri-satu">
                  <img class="img-kiri-satu" :src="image" :alt="alt">
                </div>

              </div>
              <div class=" pt-2 ">
                <slot name="p-1">
                  <h5 class="text-center">title</h5>
                </slot>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-sm-8 border-kanan bg-secondary">
        <div class="swiper">

          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Slides -->
            <div class="swiper-slide">
              <div class="row h-100">
                <div class="col-sm-10 px-3">
                  <figure>
                    <blockquote class="blockquote">
                      <h1 class="text-secondary"><i class='bi bi-quote'></i></h1>
                      <slot name="p-2">
                        <p>A well-known quote, contained in a blockquote element.</p>
                      </slot>
                    </blockquote>
                    <figcaption class="blockquote-footer">
                      <slot name="p-3">
                        <span>Someone famous in</span>
                      </slot>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {CardProps} from './CardProps'

export default {
  name: "Card908",
  props: {
    ...CardProps
  }
}
</script>

<style scoped>
.panel {
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

.border-kiri {
  border-radius: 0 15px 15px 0
}

.border-kanan {
  border-radius: 15px 0 0 15px;
}

.swiper {
  width: 100%;
  height: 250px;
}

.img-kiri-satu {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transition: ease 0.5s;
  object-fit: cover;
}

@media (max-width: 575.98px) {
  .border-kiri {
    border-radius: 15px 15px 0 0;
  }

  .border-kanan {
    border-radius: 0 0 15px 15px;
  }
}

</style>